import {
  Autocomplete,
  Button,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import React from "react";
import CustomSnackbar from "../Common/CustomSnackbar";
import CloseIcon from "@mui/icons-material/Close";
import { useParserConfigUpdate } from "./hooks/useParserConfigUpdate";
import { ParserConfigDto } from "../../types";
import { useSnackbar } from "../Common/hooks/useSnackbar";

type Prop = {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  parserConfig: ParserConfigDto | undefined;
  deviceTypeId: number;
};

const ParserConfigUpdate: React.FC<Prop> = ({ open, onClose, onSuccess, parserConfig, deviceTypeId }) => {
  const { showSuccess, showError, snackbarProps } = useSnackbar();

  const {
    parserName,
    setParserName,
    description,
    setDescription,
    connectionTypes,
    selectedConnectionType,
    setSelectedConnectionType,
    payloadTypes,
    selectedPayloadType,
    setSelectedPayloadType,
    handleUpdate,
    resetForm,
  } = useParserConfigUpdate(open, parserConfig, deviceTypeId);

  const handleSubmit = async () => {
    try {
      const successMessage = await handleUpdate();
      showSuccess(successMessage);
      resetForm();
      onClose();
      onSuccess && onSuccess();
    } catch (error) {
      showError(error as Error);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth={"sm"}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Parser Düzenle
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <Grid
          container
          direction="column"
          spacing={2}
          alignItems="center"
          sx={{ padding: 2 }}
        >
          <Grid size={{ xs: 12, sm: 10 }}>
            <TextField
              fullWidth
              size="small"
              id="parserName"
              name="parserName"
              label="Parser Adı"
              value={parserName}
              inputProps={{ maxLength: 100 }}
              onChange={(e) => setParserName(e.target.value)}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 10 }}>
            <Autocomplete
              size="small"
              options={connectionTypes}
              value={selectedConnectionType}
              getOptionLabel={(option) => option.name}
              onChange={(event, newValue) => {
                setSelectedConnectionType(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Bağlantı Tipi"
                  placeholder="Bağlantı tipi seçiniz"
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 10 }}>
            <Autocomplete
              size="small"
              options={payloadTypes}
              value={selectedPayloadType}
              getOptionLabel={(option) => option.name}
              onChange={(event, newValue) => {
                setSelectedPayloadType(newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Veri Tipi"
                  placeholder="Veri tipi seçiniz"
                />
              )}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 10 }}>
            <TextField
              fullWidth
              size="small"
              id="description"
              name="description"
              label="Açıklama"
              value={description}
              inputProps={{ maxLength: 150 }}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Grid>

          <Grid size={10} sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              size="medium"
              variant="contained"
              onClick={handleSubmit}
              sx={{
                backgroundColor: "var(--color-primary)", borderRadius: "6px", textTransform: "none", px: 4,
                "&:hover": { backgroundColor: "var(--color-primary-dark)" },
              }}
            >
              Kaydet
            </Button>
          </Grid>
        </Grid>
      </Dialog>
      <CustomSnackbar {...snackbarProps} />
    </>
  );
};

export default ParserConfigUpdate;
